import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'arrayJoin',
  standalone: false
})
export class ArrayJoinPipe implements PipeTransform {
  public transform(
    // tslint:disable-next-line: no-any
    val: Array<any>,
    key: string,
    deliMeter: string = ', '
  ): string {
    return val.map(_ => _[key]).join(deliMeter);
  }
}
